import * as _ from 'lodash';
import router from '../../router';
import store from '..';

import { SET_MENU_ITEMS } from './nav.mutations';
import { DETERMINE_MENU_ITEMS } from './nav.actions';

export default {
    state: {
        menuItems: []
    },

    mutations: {
        [SET_MENU_ITEMS]: (state, menuItems) => {
            state.menuItems = menuItems;
        }
    },

    actions: {
        [DETERMINE_MENU_ITEMS]: function (context) {
            const routes = [];
            _.forEach(router.options.routes, route => {
                if (route.meta.isMenuItem &&
                    ((route.meta.groups && _.intersection(route.meta.groups, store.getters.groups).length > 0) ||
                        !route.meta.groups)) {
                    const childRutes = [];
                    _.forEach(route.children, childRute => {
                        childRutes.push(
                            {
                                name: childRute.meta.title,
                                url: childRute.path,
                                icon: childRute.meta.icon
                            }
                        );
                    });
                    routes.push(
                        {
                            name: route.meta.title,
                            url: route.path,
                            icon: route.meta.icon,
                            children: childRutes
                        }
                    );
                }
            });
            context.commit(SET_MENU_ITEMS, routes);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/nav/nav.module.js